// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05780e5b","352":"eaeb41a9","451":"f581ef40","592":"87ee8c41","667":"989dacb1","670":"3bb4293d","876":"48eb9162"}[chunkId] + ".chunk.js";
};